module.exports = __webpack_public_path__ + "img/follow-house.62bffec5.png";